import About from '../components/About/About';

const AboutScreen = () => <About />;

export default AboutScreen;
